<div class="rolling-page">
    <div class="content">
        <div class="portalLogo"></div>
        <h2>Let's Get Rolling!</h2>
        <p>It only takes 5 minutes to create an account. Please have your driver roster, including driver’s birthdates
            and CDL information available.</p>
        <button [routerLink]="['/verification']" class="primary-button">
            Continue
        </button>
    </div>
</div>